module.exports = require("current-script-polyfill");